import backbone from 'backbone'
import $ from 'jquery'
import _ from 'underscore'
import VimeoPlayer from '@vimeo/player'
import modal from 'bootstrap/js/dist/modal'

let VideoView = Backbone.View.extend({

    el: $(document),


    players: [],

    initialize: function() {

        var _this = this

        $(window).on('resize', _.debounce(function(e) {
          _this.resize(e)
        }, 100))

        Number.prototype.pad = function(size) {
            var s = String(this)
            while (s.length < (size || 2)) {s = "0" + s;}
            return s
        }

         this.render()

    },

    events: {
        'click .home .pause-video': 'playPauseVideo',
        'click .video-fullscreen': 'playFullscreen',
        'click .video-toggle': 'playPauseVideo',
        'click .video-volume': 'volumeVideo',
        'input .timeline input': 'seekVideo',



        'click a.play-inline-video' : '_playInlineVideo',



        'click .media-play-pause' : '_playPauseFeaturedVideo',

        // 'keyup' : 'exitFullscreen',
    },

    _playPauseFeaturedVideo(e) {
        e.preventDefault()

        var iframe = $('.entry-header-video iframe')[0]
        var player = new VimeoPlayer(iframe)
        if ( $('.entry-header-video').hasClass('playing') ) {
            player.pause().then(function() {
                // the video was paused
                // alert('paused')
            }) 
        } else {
            player.play()
        }

        return false

    },

    _playInlineVideo(e) {
        e.preventDefault()

        const _this = this

        let $a = $(e.currentTarget)
        let $video = $a.parent(),
            provider = $video.attr('data-video-provider'),
            video_id = $video.attr('data-video'),
            h = null

        // let complete_vid = video_id


        if ( provider == 'youtube') {
            _this.initYTPlayer(video_id, 'player-' + video_id)
        } else if ( provider == 'vimeo' ) {
            let video_array = video_id.split('?h=')
            if ( video_array.length > 1 ){

                video_id = video_array[0]
                h = video_array[1]
            }


            _this.initVimeoPlayer(video_id, 'player-' + video_id, h)
        }

        // _this.player.playVideo()

        $video.addClass('playing')


        return false
    },

    // Youtube API
    onYouTubeIframeAPIReady: function(){
        console.log('API READY')
        var _this = this

        try {
          if ('YT' in window) {

              _this.YT = window.YT

          } else {
              window.onYouTubeIframeAPIReady = function() {
                  console.log('YT')
                  _this.YT = window.YT
              }
          }
        }
        catch(error) {

        }
    },

    initVimeoPlayer(video_id, playerContainer, h) {

        let wraper = $('#' + playerContainer).parent().parent()

        console.log(this._getVimeoThumb(video_id))
        

        console.log(wraper)

        let vimeo_player = this._isPlayerInitialized(video_id)
        console.log('vp::', h)

        if (! vimeo_player ) {

            let options = {
                // id: video_id + ( h ? '/' + h : '' ),
                url: 'https://vimeo.com/' + video_id + ( h ? '/' + h : '' ),
                width: 640,
                loop: false,
                // autoplay: true,
                byline: false,
                portrait: false,
                title: false,
                playsinline: $(window).width() <= 768 ? false : true,
                controls: true,
                ui: false,
                dnt: true
            }

            vimeo_player = new VimeoPlayer(playerContainer, options)

            vimeo_player.on('play', function(data) {
                wraper.addClass('playing')
            })

            vimeo_player.on('pause', function(data) {
                wraper.removeClass('playing')
            })

            vimeo_player.on('ended', function(data) {
                wraper.removeClass('playing')
            })


            this.players.push({
                id: video_id,
                player: vimeo_player
            })

            console.log('vp::', vimeo_player)

        }
        console.log('vp::', vimeo_player)
        vimeo_player.play()

    },

    _isPlayerInitialized(video_id) {
        if ( this.players.length ) {
            this.players.forEach( (p, i) => {

                if (p.id == video_id) {
                    return p.player
                }

            })
        }
        return false
    },



    initYTPlayer: function(video, playerContainer){

        var _this = this

        //if (!$('#video').is('iframe')) return

        var wraper = $(playerContainer).parent()

        // Init video player
        _this.player = new window.YT.Player(playerContainer, {
            'videoId': video,

            playerVars: { 

                'autoplay': 1, 
                'controls': 1, 
                'showinfo': 0, 
                'rel': 0
            },                
            events: {
              'onReady': _this.onPlayerReady,
              //'onStateChange': _this.onPlayerStateChange
            }
        })


    },

    onPlayerReady: function(e){
        console.log('PLAYER READY')

        e.target.playVideo()

        // setTimeout(function(){

            var iframe = document.querySelector('iframe#video')

            var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullscreen

            if (requestFullScreen && $('[fs="true"]').length) {
                requestFullScreen.bind(iframe)()
            }

          // }, 1000)
            
    },

    loadVimeoPlayer: function(video, fullscreen){
        var _this = this


        var options = {
            id: video,
            width: 640,
            loop: false,
            // autoplay: true,
            byline: false,
            portrait: false,
            title: false,
            playsinline: $(window).width() <= 768 ? false : true,
            controls: true,
            ui: false
        }



        _this.player = new VimeoPlayer('video', options)


        _this.player.getDuration().then(function(duration) {

            _this.player_duration = duration

        })

        _this.player.play()

        _this.player.on('play', function(data) {
            $('.video-toggle').addClass('playing')
        })

        _this.player.on('pause', function(data) {
            $('.video-toggle').removeClass('playing')
        })

        _this.player.on('ended', function(data) {
            $('.video-toggle').removeClass('playing')
        })

        _this.player.on('timeupdate', function(data) {
            
            var el = $('.video-controls')
            var seekslider = $('input', el)
            var progress_bar = $('.timeline', el)
            var position = data.percent * 100

            // console.log(position)
            seekslider.val(position)

            // this.current_position = _this.convertMS(e.currentPosition)
            // this.updateSliderTime()
            

            // Highlight current range
            var percent = seekslider.val()
            // console.log(percent)

            progress_bar.css('background-image',
                '-webkit-gradient(linear, left top, right top, ' +
                'color-stop(' + percent + '%, #C84D2B), ' +
                'color-stop(' + percent + '%, #8A351F)' +
                ')')

            progress_bar.css('background-image',
                '-moz-linear-gradient(left center, #C84D2B 0%, #8A351F ' + percent + '%, #C84D2B ' + percent + '%, #8A351F 100%)')

        })

        if (fullscreen) {
            _this.player.on('play', function(data) {


                var iframe = document.querySelector('#video iframe')

                var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullscreen

                if (requestFullScreen) {
                    console.log('PLAYING', _this.player)

                    requestFullScreen.bind(_this.player.element)()
                }
            })
        }
        // _this.player.on('play', function(data) {
        //     _this.player.setVolume(1)
        // });
        // console.log(_this.player)

    },

    playFullscreen: function(e){

        console.log('FULL SCREEN')

        var _this = this

        var iframe = document.querySelector('#video iframe')

        var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullscreen

        if (requestFullScreen) {
            console.log('PLAYING')

            requestFullScreen.bind(iframe)()

        }

        $(iframe).toggleClass('fullscreen')

        // var iframe = $('#modal-video .modal-body')
        // $('body').toggleClass('no-scroll')
        // $(iframe).toggleClass('fullscreen')

        // var button = $(e.currentTarget).parent().parent()
        // button.attr('fs', true)
        // button.modal('show')

        // console.log(button)
    },

    exitFullscreen: function(e){

        // if (e.key === "Escape" && $('#modal-video .modal-body').hasClass('fullscreen')){

        //     $('body').toggleClass('no-scroll')
        //     $(iframe).toggleClass('fullscreen')
        // }

    },

    seekVideo: function(e){

        if (this.player_duration) {

            var seekslider = $(e.currentTarget)

            var seekto = this.player_duration * (seekslider.val() / 100);

            this.player.setCurrentTime(seekto)
        }
    },

    volumeVideo: function(e){

        var el = $(e.currentTarget)
        $('span', el).toggleClass('icon-unmuted').toggleClass('icon-muted')
        
        var volume = $('span', el).hasClass('icon-unmuted') ? 1 : 0

        this.player.setVolume(volume)

    },

    videoModal: function(){

        var _this = this

        

        var mv = document.getElementById('modal-video')
        mv.addEventListener('show.bs.modal', function (e) {
          // do something...
        //   alert(3)
        // })

        // $('#modal-video').on('show.bs.modal', function(e) {

            // alert(1)

            var button = $(e.relatedTarget)
            // var caption = button.find('figcaption').text()
            var provider = button.data('video-provider')
            var title = button.data('title')
            var duration = button.data('duration')
            var fs = button.attr('fs')



            $(this).addClass(provider)
            $(e.currentTarget).find('button').data('video-provider', provider)

            if (title != '') {
                $('.caption .video-title', $(this)).text(title)
            }

            if (duration != '') {
                $('.caption .video-duration', $(this)).text(duration)
            }

            // if (title) {
            //     // title = `<h3>${title}</h3>`
            //     $('.caption', $(this)).html(title).show()
            // } else {
            //     $('.caption', $(this)).hide()
            // }

            if (window.YT && provider == 'youtube') {
                //_this.player.loadVideoById(button.data('video'))
                
                _this.initYTPlayer( button.data('video'), document.getElementById('video') )

                var iframe = document.querySelector('iframe#video')
            }

            if (provider == 'vimeo') {

                _this.loadVimeoPlayer(button.data('video'), fs)

                var iframe = document.querySelector('#video iframe')

            }

            if (button.attr('fs')) {
                // var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullscreen

                // if (requestFullScreen) {
                //     requestFullScreen.bind(iframe)()
                // }
            }
            
        })

        // Stop video on modal close
        $('#modal-video').on('hide.bs.modal', function (e) {
            

            $('.video').removeAttr('fs')
            var provider =  $(e.currentTarget).find('button').data('video-provider')

            // if (YT && provider == 'youtube') {
            //     _this.player.stopVideo()
            // }

            $('.modal-backdrop').remove()
            $('#video').replaceWith('<div id="video"></div>')
            
        })
    },

    _getVimeoThumb(id) {    
        
        return "http://vimeo.com/api/v2/video/" + id + ".json?callback=showThumb"

    },

    // homepage: function(){

    //     var _this = this

    //     if ($('body').hasClass('home')) {

    //         var video = $('#video')
    //         var options = {
    //             id: video.data('video'),
    //             muted: 1,
    //             loop: true,
    //             controls: false,
    //             autoplay: true,
    //             byline: false,
    //             portrait: false,
    //             title: false,
    //             background: true,
    //             playsinline: true
    //         }
            
    //         _this.player = new VimeoPlayer(video, options)
            

    //         // _this.player.on('error', function(e){
    //         //     console.log(e)
    //         //     $('.article-image').removeClass('with-video')
    //         // })

    //         if ($('html').hasClass('no-touch')) {

    //             _this.player.play().then(function() {
                    
    //                 _this.responsive()

    //             }).catch(function(error) {

    //                 $('.article-image').removeClass('with-video')
    //             })
            
    //         }
           
    //     }

    // },

    playPauseVideo: function(e){

        var el = $(e.currentTarget)

        this.player = new VimeoPlayer($('#video iframe'))

        if(!el.hasClass('playing')){
            this.player.play()
        } else {
            this.player.pause()
        }

        el.toggleClass('playing')
        
    },

    responsive: function(){

        if ($('body').hasClass('home')) {

          if ($('#video').length) {

            var obj = $('iframe', $('#video'))

            var winh = $(window).height(), //Browser Window height
                winw = $(window).width(),  //Browser Window width
                vidh = obj.height(),       //video object height
                vidw = obj.width(),        //video object window
                wre = winw / winh,         //ratio of window width vs window height
                hre = winh / winw,         //ratio of window height vs window width
                expected_width,
                expected_height
                
            //This section will execute if window width is greater than window height.
            if(winw > winh){
                if(wre < 1.77){
                    expected_width = winh * (16/9);
                    obj.css('width',expected_width+'px');
                    obj.css('height','100%');
                }else{
                    expected_height = winw / (16/9);
                    obj.css('width','100%');
                    obj.css('height',expected_height+'px');
                }
            //This section will execute if window height is greater than window width.
            }else{
                if(hre < 0.56){
                    expected_height = winw / (16/9);
                    obj.css('width','100%');
                    obj.css('height',expected_height+'px');
                }else{
                    expected_width = winh * (16/9);
                    obj.css('width',expected_width+'px');
                    obj.css('height','100%');
                }
            }

            // var w = $(window)
            // var iframe = $('iframe', $('#video'))
            // var portrait = w.height() >= w.width()
            
            // console.log(w.height(), w.width(), portrait)
            // if (portrait) {
            //   iframe.css({
            //     'min-height': '100vh'
            //   })
            // } else {
            //   iframe.css({
            //     'min-height': '100vw'
            //   })
            // }

          }

        }

    },

    convertMS: function( milliseconds ) {
        var hour, minute, seconds

        seconds = Math.floor(milliseconds / 1000)
        minute = Math.floor(seconds / 60)
        hour = Math.floor(minute / 60)
        seconds = seconds % 60
        minute = minute % 60
        hour = hour % 24

        return {
                hour: (hour).pad(),
                minute: (minute).pad(),
                seconds: (seconds).pad()
            }
    },


    /* CONTROL PLAYER POSITION */
    audioScrub: function(e, widget, duration){

        var _this = this

        var seekslider = $(e.currentTarget)

        // console.log(e, widget, duration)

        var seekto = duration * (seekslider.val() / 100);
        widget.seekTo(seekto)

    },


    setSliderTime: function(duration){

        var _this = this
        var total_time = duration

        if (total_time.hour > 0)    $('.total-time .h').text(total_time.hour + ':')
        if (total_time.minute > 0)  $('.total-time .m').text(total_time.minute + ':')
        if (total_time.seconds > 0) $('.total-time .s').text(total_time.seconds)

        if (total_time.hour > 0)    $('.current-time .h').text('00:')
        if (total_time.minute > 0)  $('.current-time .m').text('00:')
        if (total_time.seconds > 0) $('.current-time .s').text('00')

    },

    updateSliderTime: function(){

        var _this = this

        var current_time = _this.current_position

        if (current_time.hour > 0){
            $('.current-time .h').text(current_time.hour + ':')
        } else {
            if(_this.time_duration.hour > 0) $('.current-time .h').text('00:')
        }

        if (current_time.minute > 0){
            $('.current-time .m').text(current_time.minute + ':')
        } else {
            if(_this.time_duration.minute > 0) $('.current-time .m').text('00:')
        }

        if (current_time.seconds > 0){
            $('.current-time .s').text(current_time.seconds)
        } else {
            $('.current-time .s').text('00')
        }

    },

    /** UPDATE SLIDER POSITION */
    setSliderPosition: function(e, el){
        console.log(e)

        var _this = this

        var seekslider = $('input', el)
        var progress_bar = $('.progress--bar', el)
        var position = e.relativePosition * 100

        seekslider.val(position)

        // this.current_position = _this.convertMS(e.currentPosition)
        // this.updateSliderTime()
        

        // Highlight current range
        var percent = seekslider.val()

        progress_bar.css('background-image',
            '-webkit-gradient(linear, left top, right top, ' +
            'color-stop(' + percent + '%, #C84D2B), ' +
            'color-stop(' + percent + '%, #8A351F)' +
            ')')

        progress_bar.css('background-image',
            '-moz-linear-gradient(left center, #C84D2B 0%, #8A351F ' + percent + '%, #C84D2B ' + percent + '%, #8A351F 100%)')


    },


    soundCloudReady: function(e){
        console.log(e)
    },

    /** SOUNDCLOUD WIDGET */
    soundCloud: function(){

        var _this = this

        var controls = $('.controls')

        controls.each(function() {

            var button = $(this)
            var iframe = $('iframe', $(this))
            var progress = $(this).next()
            var slider = $('input', progress)
            var volume_button = $('.audio-volume', progress)
            var widget = SC.Widget(iframe[0].id)
            
            var duration = 0
            var volume = 100


            
            widget.bind(SC.Widget.Events.READY, function() {

                widget.getDuration(function(response){
                    console.log('DURATION', response)
                    duration = response
                })

                widget.getVolume(function(response){
                    console.log('VOLUME', response)
                    volume = response
                })

                widget.bind(SC.Widget.Events.PLAY, function() {
                    console.log('PLAY')
                    button.addClass('playing')
                })

                widget.bind(SC.Widget.Events.PAUSE, function() {
                    console.log('PAUSED')
                    button.removeClass('playing')
                })

                widget.bind(SC.Widget.Events.FINISH, function() {
                    console.log('FINISH')
                    button.removeClass('playing')
                })

                widget.bind(SC.Widget.Events.PLAY_PROGRESS, function(e) {
                    console.log('PLAY_PROGRESS')
                    _this.setSliderPosition(e, progress)

                    widget.isPaused(function(response){
                        console.log('IS PAUSED?', response)

                        if (response) {
                            button.removeClass('playing')
                        } else {
                            button.addClass('playing')
                        }
                    })
                })

                button.on('click', function(){
                    widget.toggle()
                })

                volume_button.on('click', function(){
                    $('span', $(this)).toggleClass('icon-unmuted').toggleClass('icon-muted')
                
                    var volume = $('span', $(this)).hasClass('icon-unmuted') ? 100 : 0

                    widget.setVolume(volume)
                })

                slider.on('input', function(e){
                    _this.audioScrub(e, widget, duration)
                })
            })

            
          
        })
            
        
    },

    headerFeaturedVideo() {
        var iframe = $('.entry-header-video iframe')[0]

        if ( iframe ) {
            var player = new VimeoPlayer(iframe)

            player.on('play', () => {
                $('.entry-header-video').addClass('playing')
                $('.media-play-pause span[class*="icon-"]').removeClass('icon-play').addClass('icon-pause')
            })

            player.on('pause', () => {
                $('.entry-header-video').removeClass('playing')
                $('.media-play-pause span[class*="icon-"]').addClass('icon-play').removeClass('icon-pause')
            })

            player.on('ended', () => {
                $('.entry-header-video').removeClass('playing')
                $('.media-play-pause span[class*="icon-"]').addClass('icon-play').removeClass('icon-pause')
            })
        }

    },

    resize: function(){
      this.responsive()
    },

    modal_video: function(){

        var modal_video = document.getElementById('modal-video')
        modal_video.addEventListener('show.bs.modal', function (e) {
            var el = $(e.relatedTarget)
            console.log(el)
            var video = $('iframe', el.children('.video__embed')).clone()
            $('#modal-video #video').html(video)
        })

        modal_video.addEventListener('hide.bs.modal', function (e) {
            $('#modal-video #video').html('')
        })

    },

    render: function() {
        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady()

        // this.modal_video()
        // this.homepage()

        if ($('figure.audio').length) {
            console.log('SOUNDCLOUD')

            this.soundCloud()
        }
        // console.log('RENDER')

        this.headerFeaturedVideo()

        this.modal_video()
        console.log('MODAL HERE!')
    }
})

export default VideoView